import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import { formatAge, formatDesigners } from "@seabrookstudios/pitch2table-core";
import { formatDuration, formatPlayerCount } from "../games/formatters";

/**
 * @param {object} props
 * @param {object} props.game
 */
export const FeedbackGameInfo = ({ game }) => {
  return (
    <Stack direction="column" justifyContent="center" spacing={2} mb={4}>
      <Box justifyContent="center" display="flex" flexDirection="column">
        <Typography align="center" variant="h4">
          {game.name}
        </Typography>
        <Typography align="center" variant="subtitle1">
          Designed by {game.customAuthors || formatDesigners(game.designers)}
        </Typography>
      </Box>

      <Stack direction="row" justifyContent="space-evenly">
        <Chip label={`Players: ${formatPlayerCount(game.playerCount)}`} />
        <Chip label={`Age: ${formatAge(game.age)}`} />
        <Chip label={`Duration: ${formatDuration(game.duration)}`} />
      </Stack>
    </Stack>
  );
};
